import { Children, default as React, Fragment, isValidElement } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';
import { Header, Page, RoutedTabs } from '@backstage/core-components';

import { Box, TabProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type SubRoute = {
  path: string;
  title: string;
  children: JSX.Element;
  tabProps?: TabProps<React.ElementType, { component?: React.ElementType }>;
};

const Route: (props: SubRoute) => null = () => null;

attachComponentData(Route, 'core.gatherMountPoints', true);

function createSubRoutesFromChildren(
  childrenProps: React.ReactNode,
): SubRoute[] {
  const routeType = (
    <Route path="" title="">
      <div />
    </Route>
  ).type;

  return Children.toArray(childrenProps).flatMap(child => {
    if (!isValidElement(child)) {
      return [];
    } else if (child.type === Fragment) {
      return createSubRoutesFromChildren(child.props.children);
    } else if (child.type !== routeType) {
      throw new Error('Child of ExploreLayout must be an ExploreLayout.Route');
    }

    const { path, title, children, tabProps } = child.props;
    return [{ path, title, children, tabProps }];
  });
}

type LayoutProps = {
  children?: React.ReactNode;
};

const useStyles = makeStyles({
  tabs: {
    display: 'contents',
    '& > div': {
      zIndex: 2,
    },
  },
});

export const Layout = ({ children }: LayoutProps) => {
  const routes = createSubRoutesFromChildren(children);
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Header title="Architecture Center" />
      <Box className={classes.tabs} width="100%">
        <RoutedTabs routes={routes} />
      </Box>
    </Page>
  );
};

Layout.Route = Route;
